import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { SidenavContainerComponent } from './sidenav-container.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { SidenavContentComponent } from './sidenav-content/sidenav-content.component';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  imports: [CommonModule, MatIconModule, A11yModule],
  exports: [SidenavContainerComponent, SidenavComponent, SidenavContentComponent],
  declarations: [SidenavContainerComponent, SidenavComponent, SidenavContentComponent],
})
export class SidenavModule {}
